//helper goes here for Certifications
import oracle from "../../assets/icons/oracle.png"

export type CertificationsProps = {}
export const certifications = [
    {
        title:"Oracle Certified Associate, Java SE 8 Programmer",
        date:"November 03, 2020",
        alt:"279075666OCAJSE8",
        img: oracle,
        certificate: "https://drive.google.com/file/d/1ocbB49hqBbnUkA2TPGmn2rY1xiEHhPvS/view?usp=sharing",
        cradential: "https://www.credly.com/badges/d3589744-3b7b-4abe-97af-6c35046e34ad?source=linked_in_profile"
    }
]
export {}
